export default {
  welcome: "Bienvenue dans {company}",
  errors: {
    passwordsMustMatch:
      "Les mots de passe doivent correspondre et doivent contenir au moins 6 caractères",
    allFieldsAreRequired: "Tous les champs doivent être remplis",
  },
  token: {
    completeRegistration:
      "Compléter l'inscription afin d'accepter l'invitation",
    completeLogin: "Connectez-vous pour accepter l'invitation",
  },
  countries: {
    AU: "Australie",
    AT: "Autriche",
    BE: "Belgique",
    BR: "Brézil",
    BG: "Bulgarie",
    CA: "Canada",
    CY: "Chypre",
    CZ: "Republique Tchèque",
    DK: "Danemark",
    EE: "Estonie",
    FI: "Finlande",
    FR: "France",
    DE: "Allemagne",
    GR: "Grèce",
    HK: "Hong-Kong",
    HU: "Hongrie",
    IE: "Irelande",
    IT: "Italie",
    JP: "Japon",
    LV: "Lettonie",
    LT: "Lithuanie",
    LU: "Luxembourg",
    MY: "Malaysie",
    MT: "Malte",
    MX: "Mexique",
    NL: "Pays-Bas",
    NZ: "Nouvelle-Zélande",
    NO: "Norvège",
    PL: "Pologne",
    PT: "Portugal",
    RO: "Roumanie",
    SG: "Singapour",
    SK: "Slovaquie",
    SI: "Slovénie",
    ES: "Espagne",
    SE: "Suède",
    CH: "Suisse",
    AE: "Emirats Arabes Unis",
    GB: "Angletterre",
    US: "Etats-Unis",
  },
  common: {
    thanksForJoining: "Nous sommes heureux que vous nous ayez rejoint{0}!",
    pleaseVerifyEmail:
      "Afin de compléter votre inscription, nous vous avons envoyé un courrier éléctronique de vérification pour confirmer vos informations.",
    resendVerifyEmail:
      "Si vous n'avez pas reçu de courrier éléctronique de vérification, tappez sur le boutton en-dessous pour le renvoyer.",
    or: "ou",
    login: "Se connecter",
    logout: "Se déconnecter",
    email: "Email",
    password: "Mot de passe",
    resetPassword: "Mot de passe oublié",
    confirmPassword: "Confirmer le mot de passe",
    register: "S'inscrire",
    firstName: "Prénom",
    lastName: "Nom",
    signup: "S'inscrire",
    company: "Compagnie",
    individual: "Personnel",
    country: "Pays",
    verifyEmail: "Vérifier le courrier éléctronique",
    emailSent: "courrier éléctronique envoyé",
  },
  language: {
    enUS: "Anglaise",
    frQC: "Français",
    esES: "Espagnole",
  },
  customers: {
    createProfile: "Créer un profil",
    createNewProfile: "Créer un nouveau profil",
    myCustomers: "Mes profils",
    selectAProfile: "Selectionner un profil",
    profileOptions: "Options de profils",
    emptyProfiles:
      "Il semblerait qu'il n'y ai pas de profils associés avec votre courrier éléctronique dans le système {0}",
    optionMakePayment: "Éffectuer un paiement",
    optionManageProfile: "Gérer le profil",
    inputPaymentInfo:
      "Entrer le montant du paiement que vous aimeriez éffectuer vers votre compte {0}.",
    productName: "Paiement",
    name: "Nom complet",
    proceedToCheckout: "Procéder au paiement",
    successfulPayment: "Votre paiement a été complété avec succès",
    fields: {
      description: "Description",
    },
    options: {
      payment: {
        title: "Paiement",
      },
    },
  },
  login: {
    title: "Bienvenue dans {company}",
    subtitle:
      "Pour commencer, connectez-vous avec votre identifiant ou créez en un",
    missingAccount: "Pas de compte?",
  },
  register: {
    title: "Créer un compte",
    subtitle: "Commencez votre nouvelle aventure avec {company}",
    haveExistingAccount: "Vous avez déjà un compte?",
  },
  forgotPassword: {
    title: "Ça arrive aux meilleurs d'entre-nous",
    subtitle:
      "Entrez le courrier éléctronique associé à votre compte et nous allons vous envoyer des instructions",
    backTo: "Revenir à",
    success:
      "Le courrier éléctronique pour récuperer votre mot de passe a été envoyé",
    sent: "Nous avons envoyé un lien pour réinitialiser votre mot de passe au courrier éléctronique que vous nous avez fournis.",
  },
  accounts: {
    locatedIn: "Situé dans...",
    title: "Bonjour, {name}",
    subtitle: "",
    myAccounts: "Mes comptes",
    createVerbose: "Créer un nouveau compte",
    createShort: "Creér un compte",
    newAccount: "Nouveau compte",
    iAmA: "Je suis un ...",
    agreementText:
      "En enregistrant votre compte, vous acceptez notre convention de services et le",
    agreementStripeLink: "Convention de services des compte associé à Stripe.",
    createYourFirstAccount: "Créez votre premier compte {company}",
    toBeginInstructions:
      "Pour commencer, tappez sur le boutton en-dessous et dites-nous en plus sur vous ou votre compagnie",
    connectedDisclaimer: "Ce compte sera associé à <b>{email}</b>",
    andMyNameIs: "Et mon nom est...",
    andMyCompanyNameIs: "Et le nom de ma compagnie est...",
    accountCreated: "Compte créé",
  },
  message: {
    hello: "peu importe",
  },
};
